export enum ProjectSectionEnum {
  REPORT_SECTION_PLANIFICATION = 1,
  REPORT_SECTION_FINANCIAL,
  REPORT_SECTION_ACCORDANCE,
  REPORT_SECTION_RISK,
  REPORT_SECTION_PRODUCTS,
  REPORT_SECTION_MANAGEMENT,
}
